module.exports = __webpack_public_path__ + "static/media/cv-icon.6efac0ae.png";